import axiosInstance from "api/axiosInstance"

import { providerDashboardAction } from "./provider-dashboard-slice"

import exportAxiosInstance from "api/exportAxiosInstance"

import FileSaver from "file-saver"

import { batch } from "react-redux"

import {
  buildFilterParams,
  buildFlatFilterParams,
} from "utils/providerDashboardFilters"

const dashboardRequestConfig = (filters, extraParams = {}) => ({
  params: {
    ...buildFilterParams(filters),

    ...extraParams,
  },
})

let provinceMapRequestSequence = 0

//Get Provider Stock

export const getProviderStock =
  (filters = {}) =>
  dispatch => {
    dispatch(
      providerDashboardAction.setProviderStock({
        loading: true,

        error: null,

        data: null,
      })
    )

    axiosInstance

      .get(`/v1/get-provider-stock`, dashboardRequestConfig(filters))

      .then(respnose => {
        dispatch(
          providerDashboardAction.setProviderStock({
            loading: false,

            error: null,

            data: respnose?.data,
          })
        )
      })

      .catch(error => {
        dispatch(
          providerDashboardAction.setProviderStock({
            loading: false,

            error: error?.response,

            data: null,
          })
        )

        console.log(error)
      })
  }

//Get Provider Ips

export const getProviderIps = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderIps({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-ips`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderIps({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderIps({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Projects

export const getProviderProjects = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderProjects({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-projects`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderProjects({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderProjects({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Shipments

export const getProviderShipments = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderShipments({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-shipments`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderShipments({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderShipments({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Fund Codes

export const getProviderFundCodes = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderFundCodes({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-fund-codes`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderFundCodes({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderFundCodes({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Unit Classification

export const getProviderCommodityClassifications = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderCommodityClassifications({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-commodity-classifications`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderCommodityClassifications({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderCommodityClassifications({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Item Categories

export const getProviderItemCategories =
  (commodityClassificationId = null) =>
  dispatch => {
    dispatch(
      providerDashboardAction.setProviderItemCategories({
        loading: true,

        error: null,

        data: null,
      })
    )

    axiosInstance

      .get(`/v1/get-provider-itemCategories`, {
        params: commodityClassificationId
          ? { commodity_classification_id: commodityClassificationId }
          : {},
      })

      .then(respnose => {
        dispatch(
          providerDashboardAction.setProviderItemCategories({
            loading: false,

            error: null,

            data: respnose?.data,
          })
        )
      })

      .catch(error => {
        dispatch(
          providerDashboardAction.setProviderItemCategories({
            loading: false,

            error: error?.response,

            data: null,
          })
        )

        console.log(error)
      })
  }

//Get Provider Currencies

export const getProviderCurrencies = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderCurrencies({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-currencies`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderCurrencies({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderCurrencies({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Items

export const getProviderItems = id => dispatch => {
  dispatch(
    providerDashboardAction.setProviderItems({
      loading: true,

      error: null,

      data: [],
    })
  )

  axiosInstance

    .get(`/v1/get-provider-items/${id}`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderItems({
          loading: false,

          error: error?.response,

          data: [],
        })
      )

      console.log(error)
    })
}

//Get Provider In Items

export const getProviderInItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderInItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-stock-ins`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderInItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderInItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Other Source Items

export const getProviderOtherSourceItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderOtherSourceItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-other-source-receipts`, {
      params: params ? params : {},
    })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderOtherSourceItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderOtherSourceItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Exchange Items

export const getProviderExchangeItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderExchangeItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-exchange-distributions`, {
      params: params ? params : {},
    })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderExchangeItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderExchangeItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Adjustment Increase Items

export const getProviderAdjustmentIncreaseItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderAdjustmentIncreaseItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-adjustment-increase`, {
      params: params ? params : {},
    })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderAdjustmentIncreaseItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderAdjustmentIncreaseItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Adjustment Decrease Items

export const getProviderAdjustmentDecreaseItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderAdjustmentDecreaseItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-adjustment-decrease`, {
      params: params ? params : {},
    })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderAdjustmentDecreaseItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderAdjustmentDecreaseItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Out Items

export const getProviderOutItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderOutItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-stock-outs`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderOutItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderOutItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Ips Stock

export const getProviderIpsStock = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderIpsStock({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-ips-stock`, {
      params: params ? buildFlatFilterParams(params) : {},
    })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderIpsStock({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderIpsStock({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Export Provider Ips Stock

export const exportProviderIpsStock = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderIpsStockExport({
      loading: true,

      error: null,
    })
  )

  exportAxiosInstance

    .get(`/v1/export-provider-ips-stock`, {
      params: params ? buildFlatFilterParams(params) : {},
    })

    .then(response => {
      const dataBlob = new Blob([response?.data], {
        type: "application/pdf,",
      })

      FileSaver.saveAs(
        dataBlob,

        `Provider-IPs-Inventory-Report-${Math.random().toString()}.xlsx`
      )

      dispatch(
        providerDashboardAction.setProviderIpsStockExport({
          loading: false,

          error: null,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderIpsStockExport({
          loading: false,

          error: error?.response,
        })
      )
    })
}

//Get Provider Ips Items In

export const getProviderIPsInItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderInItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-ips-stock-ins`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderInItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderInItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Ips Items Out

export const getProviderIPsOutItems = params => dispatch => {
  dispatch(
    providerDashboardAction.setProviderOutItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-ips-stock-outs`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderOutItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderOutItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Warehouses

export const getProviderWarehouses = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderWarehouses({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-warehouses`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderWarehouses({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderWarehouses({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Providers

export const getProviderProviders = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderProviders({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-providers`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderProviders({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderProviders({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Provinces

export const getProviderProvinces = () => dispatch => {
  dispatch(
    providerDashboardAction.setProviderProvinces({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-provinces`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderProvinces({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderProvinces({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider Facilities

export const getProviderFacilities = id => dispatch => {
  dispatch(
    providerDashboardAction.setProviderFacilities({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-provider-facilities/${id}`)

    .then(respnose => {
      dispatch(
        providerDashboardAction.setProviderFacilities({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        providerDashboardAction.setProviderFacilities({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

//Get Provider To Provider Pending Count

export const getProviderToProviderPendingCount = () => dispatch => {
  dispatch(providerDashboardAction.setProviderToProviderPendingCount(0))

  axiosInstance

    .get("/v1/provider-to-provider-pendingCount")

    .then(response => {
      if (response) {
        batch(() => {
          dispatch(
            providerDashboardAction.setProviderToProviderPendingCount(
              response?.data
            )
          )
        })
      }
    })

    .catch(error => {
      dispatch(providerDashboardAction.setProviderToProviderPendingCount(0))

      console.log(error)
    })
}

const setRealtimeLoading = key =>
  providerDashboardAction[`setRealtime${key}`]({
    loading: true,
    error: null,
    data: null,
  })

const setRealtimeSuccess = (key, response) =>
  providerDashboardAction[`setRealtime${key}`]({
    loading: false,

    error: null,

    data: response?.data?.data,
  })

const setRealtimeError = (key, error) =>
  providerDashboardAction[`setRealtime${key}`]({
    loading: false,

    error: error?.response,

    data: null,
  })

const DATASET_STATE_KEYS = {
  stock: "Stock",

  receipts: "Receipts",

  distributions: "Distributions",

  consumption: "Consumption",
}

const DATASET_ENDPOINTS = {
  stock: "/v1/provider/dashboard/stock",

  receipts: "/v1/provider/dashboard/receipts",

  distributions: "/v1/provider/dashboard/distributions",

  consumption: "/v1/provider/dashboard/consumption",
}

export const fetchProviderRealtimeDashboardConfig =
  (filters = {}, isCascadeRefresh = false) =>
  (dispatch, getState) => {
    if (isCascadeRefresh) {
      const existing =
        getState().providerDashboard.realtime?.config?.data ?? null
      dispatch(
        providerDashboardAction.setRealtimeConfig({
          loading: true,
          error: null,
          data: existing,
        })
      )
    } else {
      dispatch(setRealtimeLoading("Config"))
    }

    axiosInstance

      .get("/v1/provider/dashboard/config", dashboardRequestConfig(filters))

      .then(response => dispatch(setRealtimeSuccess("Config", response)))

      .catch(error => dispatch(setRealtimeError("Config", error)))
  }

export const fetchProviderRealtimeSummary =
  (filters = {}) =>
  dispatch => {
    dispatch(setRealtimeLoading("Summary"))

    axiosInstance

      .get("/v1/provider/dashboard/summary", dashboardRequestConfig(filters))

      .then(response => dispatch(setRealtimeSuccess("Summary", response)))

      .catch(error => dispatch(setRealtimeError("Summary", error)))
  }

export const fetchProviderRealtimeTable =
  (dataset = "stock", filters = {}) =>
  dispatch => {
    const stateKey = DATASET_STATE_KEYS[dataset] || "Stock"

    const endpoint = DATASET_ENDPOINTS[dataset] || DATASET_ENDPOINTS.stock

    dispatch(setRealtimeLoading(stateKey))

    axiosInstance

      .get(endpoint, dashboardRequestConfig(filters))

      .then(response => dispatch(setRealtimeSuccess(stateKey, response)))

      .catch(error => dispatch(setRealtimeError(stateKey, error)))
  }

export const fetchProviderDashboardChart =
  ({ filters = {}, chartType, dataset = "stock", metric } = {}) =>
  dispatch => {
    if (!chartType) {
      return
    }

    const chartMetric = chartType === "map" ? metric || dataset : null

    dispatch(
      providerDashboardAction.setRealtimeChart({
        loading: true,

        error: null,

        data: null,

        type: chartType,

        dataset,

        metric: chartMetric,

        hasData: false,
      })
    )

    const chartParams = dashboardRequestConfig(filters, {
      dataset,
      ...(chartMetric ? { metric: chartMetric } : {}),
    })

    axiosInstance

      .get(
        `/v1/provider/dashboard/charts/${chartType}`,

        chartParams
      )

      .then(response => {
        const payload = response?.data?.data || {}

        dispatch(
          providerDashboardAction.setRealtimeChart({
            loading: false,

            error: null,

            data: payload.data || [],

            type: payload.type || chartType,

            dataset: payload.dataset || dataset,

            metric: payload.metric || chartMetric || null,

            hasData: Boolean(payload.has_data),
          })
        )
      })

      .catch(error => {
        dispatch(
          providerDashboardAction.setRealtimeChart({
            loading: false,

            error: error?.response,

            data: null,

            type: chartType,

            dataset,

            metric: chartMetric,

            hasData: false,
          })
        )
      })
  }

export const fetchProviderProvinceMap =
  ({ filters = {}, type = "receipt" } = {}) =>
  (dispatch, getState) => {
    const requestId = ++provinceMapRequestSequence

    dispatch(
      providerDashboardAction.setProvinceMap({
        loading: true,

        error: null,

        data: null,

        type,
      })
    )

    axiosInstance

      .get(
        `/v1/get-provider-province-map/${type}`,
        dashboardRequestConfig(filters)
      )

      .then(response => {
        if (requestId !== provinceMapRequestSequence) {
          return
        }

        const payload = response?.data?.data || {}

        dispatch(
          providerDashboardAction.setProvinceMap({
            loading: false,

            error: null,

            data: payload,

            type: payload.type || type,
          })
        )
      })

      .catch(error => {
        if (requestId !== provinceMapRequestSequence) {
          return
        }

        dispatch(
          providerDashboardAction.setProvinceMap({
            loading: false,

            error: error?.response,

            data: null,

            type,
          })
        )
      })
  }

const resolveDashboardChartRequest = ({
  chartType,
  dataset = "stock",
} = {}) => {
  if (!chartType || chartType === "map") {
    return null
  }

  if (chartType === "stock") {
    return { chartType: "bar", dataset: "stock" }
  }

  if (chartType === "horiz-bar") {
    return { chartType: "bar", dataset }
  }

  return { chartType, dataset }
}

const CHART_TYPE_MAP = {
  bar: { chartType: "bar", dataset: "stock" },

  line: { chartType: "line", dataset: "stock" },

  pie: { chartType: "pie", dataset: "stock" },
}

export const fetchSectionChartData =
  ({ filters = {}, section, chartType, dataset = "stock" } = {}) =>
  dispatch => {
    if (!section || !chartType) return

    dispatch(
      providerDashboardAction.setSectionChartData({
        section,

        loading: true,

        error: null,

        data: null,

        hasData: false,
      })
    )

    const params = dashboardRequestConfig(filters, { dataset })

    axiosInstance

      .get(`/v1/provider/dashboard/charts/${chartType}`, params)

      .then(response => {
        const payload = response?.data?.data || {}

        dispatch(
          providerDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: null,

            data: payload.data || [],

            dataset,

            hasData: Boolean(payload.has_data),
          })
        )
      })

      .catch(error => {
        dispatch(
          providerDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: error?.response,

            data: null,

            hasData: false,
          })
        )
      })
  }

export const fetchSectionMapData =
  ({ filters = {}, type = "receipt" } = {}) =>
  dispatch => {
    const section = "map"

    dispatch(
      providerDashboardAction.setSectionChartData({
        section,

        loading: true,

        error: null,

        data: null,

        hasData: false,
      })
    )

    axiosInstance

      .get(
        `/v1/get-provider-province-map/${type}`,
        dashboardRequestConfig(filters)
      )

      .then(response => {
        const payload = response?.data?.data || {}

        dispatch(
          providerDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: null,

            data: payload,

            type,

            hasData: Boolean(payload.has_data),
          })
        )
      })

      .catch(error => {
        dispatch(
          providerDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: error?.response,

            data: null,

            hasData: false,
          })
        )
      })
  }

export const fetchProviderRealtimeDashboard =
  ({
    filters = {},
    chartType = null,
    mapType = "receipt",
    dataset = "stock",
  } = {}) =>
  dispatch => {
    dispatch(fetchProviderRealtimeSummary(filters))

    dispatch(getProviderStock(filters))

    if (chartType === "map") {
      dispatch(fetchProviderProvinceMap({ filters, type: mapType }))

      return
    }

    const chartRequest = resolveDashboardChartRequest({ chartType, dataset })

    if (chartRequest) {
      dispatch(
        fetchProviderDashboardChart({
          filters,

          chartType: chartRequest.chartType,

          dataset: chartRequest.dataset,
        })
      )
    }
  }

export const fetchAllDashboardSections =
  ({ filters = {} } = {}) =>
  dispatch => {
    dispatch(fetchProviderRealtimeSummary(filters))

    dispatch(getProviderStock(filters))

    Object.entries(CHART_TYPE_MAP).forEach(([section, config]) => {
      dispatch(
        fetchSectionChartData({
          filters,

          section,

          chartType: config.chartType,

          dataset: config.dataset,
        })
      )
    })

    dispatch(fetchSectionMapData({ filters, type: "receipt" }))
  }

export const exportProviderRealtimeDashboard =
  ({ filters = {}, dataset = "stock", format = "xlsx" } = {}) =>
  dispatch => {
    dispatch(
      providerDashboardAction.setRealtimeExportState({
        loading: true,
        error: null,
      })
    )

    const exportParams = dashboardRequestConfig(filters, { dataset })

    return exportAxiosInstance

      .get(`/v1/provider/dashboard/export/${format}`, {
        ...exportParams,

        responseType: "blob",
      })

      .then(response => {
        const extension =
          format === "csv" ? "csv" : format === "pdf" ? "pdf" : "xlsx"

        const mimeType =
          format === "csv"
            ? "text/csv"
            : format === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

        FileSaver.saveAs(
          new Blob([response.data], { type: mimeType }),

          `provider-dashboard-${dataset}.${extension}`
        )

        dispatch(
          providerDashboardAction.setRealtimeExportState({
            loading: false,
            error: null,
          })
        )

        return Promise.resolve()
      })

      .catch(error => {
        dispatch(
          providerDashboardAction.setRealtimeExportState({
            loading: false,

            error: error?.response,
          })
        )

        return Promise.reject(error)
      })
  }
